import { Observable, Subscription } from 'rxjs';
import { Maybe } from 'maybe-not';
import MessageBus, {
    IMessageBus,
    ITectonSuccessResponse,
    _sendMessage,
    sendMessage,
    sendBroadcast
} from 'q2-tecton-common/lib/utility/message-bus';

export { sendMessage, _sendMessage };

export default class SDKMessageBus extends MessageBus implements IMessageBus {
    forwarderSubscription: Subscription;
    constructor() {
        super();

        this.forwarderSubscription = this.firehose$.subscribe((e: MessageEvent) => {
            // PREVENTS ENDLESS LOOP in window running platform and sdk
            if (e.source === window || window.parent === window) {
                return;
            }

            const protocol = e.data.protocol;

            switch (protocol) {
                case 'REQUEST':
                    this.sendRequest(e.data.type, Maybe.maybe(e.data.value)).then(response => {
                        _sendMessage(
                            e.source as Window,
                            e.data.type,
                            'RESPONSE',
                            Maybe.maybe(JSON.stringify(response.value)),
                            e.data.guid,
                            response.status
                        );
                    });
                    break;
                case 'BROADCAST':
                    sendBroadcast(e.data.type, Maybe.maybe(e.data.value));
                    break;
                case 'MESSAGE':
                    _sendMessage(window.parent, e.data.type, 'MESSAGE', Maybe.maybe(e.data.value));
                    break;
                default:
                    break;
            }
        });
    }

    onBroadcast<T>(type: string): Observable<ITectonSuccessResponse<T>> {
        return this.onMessage<T>(type, 'BROADCAST');
    }

    destroy() {
        this.forwarderSubscription.unsubscribe();
    }
}
